<template>
  <span
    :class="$style['icon']"
    class="icon-wrapper"
  >
    <slot name="svg" />
  </span>
</template>

<script>
export default {};
</script>

<style lang="scss" module>
@import "../../scss/mixins.scss";

.icon,
svg {
  display: block;
  @include mobile() {
    width: auto !important;
  }
}
.icon {
  margin: 0px 0.25em;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/icon.vue